export const numberWithCommas = (data?: number | string) => data?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
